import React from 'react'

export type LinkBoxProps = {
  href: string,
  label: string,
  target?: string
};

const LinkBox: React.FC<LinkBoxProps> = ({
  href,
  label,
  target = "_self"
}) => {
  return (
    <a href={href} target={target} className="w-full bg-gray-300 h-20 flex items-center justify-center text-center border border-gray-300 hover-border-color-secondary">
      <p className='text-xl font-bold' dangerouslySetInnerHTML={{
        __html: label
      }}></p>
    </a>
  );
}

export default LinkBox;